import * as yup from "yup";

import {
	checkSINValidity,
	isAtLeast10YearsOld,
	isMasked,
	isValidDate,
} from "../../common/Common";

export const EmployeeSetupValidationSchema = yup.object({
	firstName: yup
		.string()
		.required("First Name is required")
		.min(1, "First Name has at most 1 characters")
		.max(25, "First Name has at most 25 characters"),
	lastName: yup
		.string()
		.required("Last Name is required")
		.min(1, "Last Name has at most 1 characters")
		.max(25, "Last Name has at most 25 characters"),
	initial: yup
		.string()
		// .required("Last Name is required")
		// .min(1, "Minimum length 1 characters")
		.max(3, "Maximum length 3 characters"),
	addressLine1: yup
		.string()
		.required("Address is required")
		.min(1, "Minimum length 1 characters")
		.max(100, "Maximum length 100 characters"),
	city: yup
		.string()
		.required("City is required")
		.min(1, "Minimum length 1 characters")
		.max(30, "Maximum length 30 characters"),
	province: yup.string().required("Province is required"),
	payFrequency: yup.string().required("Payroll Schedule is required"),
	country: yup.string().required("Country is required"),
	dateOfBirth: yup
		.date()
		.typeError("Invalid date format") // Ensures the input is a valid date
		.required("Date of birth is required")
		.max(
			new Date(new Date().setFullYear(new Date().getFullYear() - 10)),
			"Date of birth must be at least 10 years back",
		),
	// dateOfBirth: yup
	//   .mixed()
	//   .nullable()
	//   .test("dob-validation", function (value) {
	//     if (!value) {
	//       return this.createError({ message: "Date of birth is required" });
	//     }

	//     // ✅ Skip all validation if masked
	//     if (isMasked(value)) return true;

	//     if (!isValidDate(value)) {
	//       return this.createError({ message: "Invalid date format" });
	//     }

	//     if (!isAtLeast10YearsOld(value)) {
	//       return this.createError({
	//         message: "Date of birth must be at least 10 years back",
	//       });
	//     }

	//     return true;
	//   }),

	stubLanguage: yup.number().required("Stub Language is required"),
	emailStub: yup
		.number()
		// .email("Must be a valid email address")
		.required("Email Stub is required"),
	email: yup
		.string()
		// .trim()
		.email("Must be a valid email address")
		// .matches(/\.[A-Za-z]{2,}$/, "Must be a valid email address")
		.matches(/\.[A-Za-z]{2,}$/, {
			message: "Must be a valid email address",
			excludeEmptyString: true,
		})
		.nullable(),
	printHourlyRateOnStub: yup
		.number()
		.required("Print hourly rate on stub Stub is required"),
	provinceOfEmployment: yup
		.string()
		.required("Province of Employment is required"),
	// dateOfHire: yup
	//   .date()
	//   .typeError("Invalid date format") // Ensures the input is a valid date
	//   .required("Date of Hire is required"),
	payMethod: yup.number().required("Pay Method is required"),
	followUpNotes: yup.string().max(500, "Maximum length 500 characters"),
});
